import React from 'react';
import camelCase from 'lodash/camelCase';

import Text from '../components/Text';
import MdBold from '../components/MdBold';
import Image from '../components/Image';
import Button from '../components/Button';

import Input from '../components/Survey/TextInput';
import Choice from '../components/Survey/Choice';
import Matrix from '../components/Survey/MatrixChoice';
import Sort from '../components/Survey/Sort';
import Slider from '../components/Survey/Slider';
import List from '../components/Survey/List';
import TextOnPic from '../components/Survey/TextOnPic';
import Decisions from '../components/Survey/Decisions';
import Dropdown from '../components/Survey/Dropdown';

import { withReduxContext } from '../stores/surveyStore';

import checkImage from '../components/utils/checkImage';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const Modules = {
  Title: Text.h1,
  SectionTitle: Text.h3,
  Text: (props) => <MdBold fontSize="1.25em" whiteSpace="pre-wrap" {...props} />,
  Image: ({ src, ...props }) => <Image src={checkImage(src)} {...props} />,
  List,
  Choice: withReduxContext(Choice),
  Matrix,
  Sort,
  TextOnPic,
  Slider,
  Input,
  Dropdown,
  Decision: Decisions,
  Button,
};

export default (type, variation) => {
  const Module = Modules[capitalizeFirstLetter(camelCase(type))];
  return variation ? Module[variation] : Module;
}
